import {useMemo} from "react";

import {BACKEND_APIS, USER_ROLES, WEBBACK_V2_API} from "@constants";
import {useUserApp} from "@hooks";


export default function useProductPageDetailsRoleConfig() {
	const { userRole } = useUserApp()

	// `details/context` is served by dipi-webback-v2 (single HeatWave query, see
	// dipi-webback-v2/plans/869e5pfw2--data-product-page.md F3). The MARKETPLACES branch stays on
	// the legacy webback on purpose: v2 does not migrate that role, so `details-seller` only
	// exists there.
	const urlApiTable = useMemo(() => ({
		[USER_ROLES.STANDARD]: `${WEBBACK_V2_API}/product-page/details/context`,
		[USER_ROLES.RETAILER]: `${WEBBACK_V2_API}/product-page/details/context`,
		[USER_ROLES.MARKETPLACES]: `${BACKEND_APIS.PRODUCT_PAGE}/details-seller/context`,
	})[userRole], [userRole])

	// The export is on v2 as well, and by construction it cannot drift from the table: the service
	// runs `details/context` and formats the rows it returns.
	const urlApiExcel = useMemo(() => ({
		[USER_ROLES.STANDARD]: `${WEBBACK_V2_API}/product-page/details/excel`,
		[USER_ROLES.RETAILER]: `${WEBBACK_V2_API}/product-page/details/excel`,
		[USER_ROLES.MARKETPLACES]: `${BACKEND_APIS.PRODUCT_PAGE}/details-seller/excel`,
	})[userRole], [userRole])

	return {
		urlApi: urlApiTable,
		urlApiExcel: urlApiExcel,
		isMarketplacesUser: userRole === USER_ROLES.MARKETPLACES
	}
}
